import React, { useState } from 'react';
import * as Unicons from '@iconscout/react-unicons';
import AdminLayout from '../../components/layout/admin';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import './styles.scss';
import RaterInputForm from '../principal_rater_form_input/RaterInputForm';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getMasterRater } from '../../services/masterRater';
import { useDisclosure } from '@mantine/hooks';
import { useHistory, useParams } from 'react-router-dom';
import ModalConfirmation from '../../components/fragments/ModalConfirmation';
import {
  getExpectationFormDetail,
  postExpectationForm,
  updateExpectationForm
} from '../../services/expectationForm';
import { showNotification } from '../../utilities/mantineNotification';

const ManagementExpectationFormEditPage = (props) => {
  const [opened, { open, close }] = useDisclosure(false);
  const [dataPayload, setDataPayload] = useState(null);

  const history = useHistory();
  const params: any = useParams();
  // Queries
  const fetchedRaterForm = useQuery({
    queryKey: ['getMasterRater'],
    queryFn: () =>
      getMasterRater({
        page: 1,
        userin: params.userid,
        scheduleid: params.id
      })
  });

  const inputExpectationForm = useMutation({
    mutationFn: updateExpectationForm,
    onSuccess: () => {
      fetchedRaterForm.refetch();
      close();
      showNotification({
        type: 'success',
        message: 'Expectation Form Submitted'
      });
      history.push({
        pathname: '/management/expectation-form/detail/' + params.id
      });
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const detailExpectationForm = useQuery({
    queryKey: ['getExpectationFormDetail'],
    queryFn: () => getExpectationFormDetail(params?.id)
  });

  const handleSubmit = (payload) => {
    const payloadMod = {
      ...payload,
      scheduleRaterID:
        detailExpectationForm.data?.data?.data[0]?.scheduleRaterID,
      insertID: params.id,
      userID: params.userid,
      userIn: params.userid,
      isPublished: 'Y',
      sinopsis: 'string'
    };
    setDataPayload(payloadMod);
    open();
  };

  const handleConfirmSubmit = () => {
    inputExpectationForm.mutate(dataPayload);
  };

  return (
    <AdminLayout>
      <Breadcrumbs
        pageTitle="Expectation Form Edit"
        itemList={[
          {
            title: 'RATER',
            href: '#',
            icon: <Unicons.UilFileCopyAlt size={16} />
          },
          {
            title: 'Detail Expectation Form',
            href: '/management/expectation-form/detail/' + params.id
          },
          {
            title: 'Expectation Form',
            href: '/management/expectation-form/detail/' + params.id
          }
        ]}
      />

      <RaterInputForm
        questions={fetchedRaterForm?.data?.data?.data}
        onSubmit={handleSubmit}
        type="expectation"
      />

      <ModalConfirmation
        isVisible={opened}
        onCancel={() => close()}
        onConfirm={() => handleConfirmSubmit()}
      />
    </AdminLayout>
  );
};

export default ManagementExpectationFormEditPage;
